export default __webpack_public_path__ + "static/media/tela_receeba.77985ead.png";